// api
import { fetchApi } from '@/api'
import router from '@/router'
// actions
const schoolroutesVehiclesAll = (context) => {
  let url = 'schoolroutes/vehicles'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_ALL', response)
      router.push('/papeleria/requests/recreate')
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesVehiclesForm = (context) => {
  let url = 'schoolroutes/vehicles/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesVehiclesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  console.log(obj)
  let url = 'schoolroutes/vehicles' + obj.id + '/edit'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const schoolroutesVehiclesCreate = (context) => {
  let url = 'schoolroutes/vehicles/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesVehiclesUpdate = (context) => {
  let url = 'schoolroutes/vehicles'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_VEHICLES_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesVehiclesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'schoolroutes/vehicles/' + obj.id
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_VEHICLES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesExisteConductor = (context, array) => {
  let url = 'schoolroutes/consultarCo'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesExisteMonitor = (context, array) => {
  let url = 'schoolroutes/consultarMo'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesExisteAlumno = (context, array) => {
  let url = 'schoolroutes/consultarAl'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_PERMISS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}


const schoolroutescrearVehiculos = (context, array) => {
  let url = 'schoolroutes/crearVehiculo'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_LIST_CREAR', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesactualizaVehiculos = (context, array) => {
  let url = 'schoolroutes/actualizaVehiculo'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_LIST_ACTUALIZA', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesbuscarVehiculos = (context, array) => {
  let url = 'schoolroutes/buscarVehiculo'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_VEHICLES_LIST_BUSCAR', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesVehiculosAll = (context) => {
  let url = 'schoolroutes/vehicles'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTERS_VEHICLES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
          console.error(error)
    })
}

const schoolRoutesVehiculosByPlaca = (context,data) => {
  let url = 'schoolroutes/vehicles/'+data.placa
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('SCHOOLROUTERS_VEHICLES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
          console.error(error)
    })
}

export default {
  schoolroutesVehiclesAll,
  schoolroutesVehiclesForm,
  schoolroutesVehiclesShow,
  schoolroutesVehiclesCreate,
  schoolroutesVehiclesUpdate,
  schoolroutesVehiclesDelete,
  schoolroutesExisteConductor,
  schoolroutesExisteMonitor,
  schoolroutescrearVehiculos,
  schoolroutesExisteAlumno,
  schoolRoutesVehiculosByPlaca,
  schoolRoutesVehiculosAll,
  schoolroutesbuscarVehiculos,
  schoolroutesactualizaVehiculos
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/vehicles/actions.js